export const CLOSEOUT_TESTID_PREFIX = 'closeout';

export const testIdSlug = (value?: string | number | null): string =>
  String(value ?? '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

export const closeoutTestId = (...parts: Array<string | number | null | undefined>): string =>
  [CLOSEOUT_TESTID_PREFIX, ...parts.map(testIdSlug)].filter(Boolean).join('-');

export const closeoutRowTestId = (
  base: string,
  identity: string | number | null | undefined,
  suffix?: string
): string | undefined =>
  testIdSlug(identity) ? closeoutTestId(base, identity, suffix) : undefined;

export const periodKey = (range?: { startDate?: string; endDate?: string } | null): string =>
  [range?.startDate, range?.endDate].filter(Boolean).join('-');

export const closeoutOptionalTestId = (key?: string | null): string | undefined =>
  testIdSlug(key) ? closeoutTestId(key) : undefined;

export const closeoutOptionTestId = (
  key: string | null | undefined,
  value: string | number | null | undefined
): string | undefined => (testIdSlug(key) ? closeoutRowTestId(`${key}-option`, value) : undefined);
